import React, { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * TenantContext provides context for tenant-related information.
 * Default value is null.
 */
export const TenantContext = createContext(null);

/**
 * TenantProvider component that provides tenant context to its children.
 *
 * @param {Object} props - The properties for TenantProvider.
 * @param {*} props.value - The tenant context value.
 * @param {React.ReactNode} props.children - The children nodes.
 * @returns {JSX.Element} A provider component for TenantContext.
 */
export const TenantProvider = ({ value, children }) => {
	return (
		<TenantContext.Provider value={value}>
			{children}
		</TenantContext.Provider>
	);
};

TenantProvider.propTypes = {
	value: PropTypes.any,
	children: PropTypes.node.isRequired,
};
